export const e_WrongProps = (e:Error) => {
    e.name="Wrong use of Props";
    return e;
}